import { statusLabel } from './statusRegistry';

/** The template filter values, shared by the member page and System Admin. The URL key stays `review=pending`. */
export type TemplateStatusFilter = 'all' | 'draft' | 'pending' | 'live';

/**
 * One definition of the template filter options, so Processor Templates and
 * System Admin → All Templates cannot drift apart again ("In review" on one,
 * "Pending review" on the other).
 *
 * Each option reads its state's word from the StatusBadge registry. The four
 * form a NON-OVERLAPPING partition — Draft is defined as neither live nor in
 * review — so every template is reachable under exactly one option besides
 * "All templates". Badge-only states (Rejected, Update available) must not be
 * added here: a row's badge shows its highest-priority state, so the Live
 * option can legitimately hold a row badged In review.
 *
 * Each page keeps its own matching (the member page filters in the browser,
 * System Admin on the server); only the words live here.
 */
export const TEMPLATE_FILTER_OPTIONS: ReadonlyArray<{ value: TemplateStatusFilter; label: string }> = [
  { value: 'all', label: 'All templates' },
  { value: 'draft', label: statusLabel('draft') },
  { value: 'pending', label: statusLabel('pending_review') },
  { value: 'live', label: statusLabel('live') },
];
